import { Button } from '@ophelos/ui/components/button';
import { Loader } from '@ophelos/ui/components/loader';
import { Lock } from 'lucide-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';
import { useUserPermissions } from '../../hooks/useUserPermissions';

interface SystemAdminProtectedRouteProps {
  children: ReactNode;
}

/**
 * Protects routes so only system-admin role can access.
 * Use for admin tools (balance lookup, communication pools, etc.).
 */
export function SystemAdminProtectedRoute({ children }: SystemAdminProtectedRouteProps) {
  const { isSystemAdmin, isLoading } = useUserPermissions();
  const navigate = useNavigate();

  if (isLoading) {
    return <Loader text="Checking permissions..." />;
  }

  if (!isSystemAdmin) {
    return (
      <div className="flex h-(--page-main-height) items-center justify-center p-4">
        <div className="w-full max-w-md">
          <Empty>
            <EmptyHeader>
              <EmptyMedia variant="error">
                <Lock />
              </EmptyMedia>
              <EmptyTitle>Access denied</EmptyTitle>
              <EmptyDescription>This page requires system-admin role.</EmptyDescription>
              <Button variant="default" className="mt-4" onClick={() => navigate('/apps')}>
                Back to apps
              </Button>
            </EmptyHeader>
          </Empty>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
